import script from "./app.vue?vue&type=script&setup=true&lang=js"
export * from "./app.vue?vue&type=script&setup=true&lang=js"

import "./app.vue?vue&type=style&index=0&id=24590dca&lang=scss"

const __exports__ = script;

export default __exports__